import empty from "assets/albion-gallery/empty.png";

import sword1 from "assets/albion-gallery/Adept's Broadsword.png";
import sword5 from "assets/albion-gallery/Adept's Carving Sword.png";
import sword4 from "assets/albion-gallery/Adept's Clarent Blade.png";
import sword2 from "assets/albion-gallery/Adept's Claymore.png";
import sword3 from "assets/albion-gallery/Adept's Dual Swords.png";
import sword6 from "assets/albion-gallery/Adept's Galatine Pair.png";
import sword8 from "assets/albion-gallery/Adept's Infinity Blade.png";
import sword7 from "assets/albion-gallery/Adept's Kingmaker.png";

import axe1 from "assets/albion-gallery/Adept's Battleaxe.png";
import axe6 from "assets/albion-gallery/Adept's Bear Paws.png";
import axe4 from "assets/albion-gallery/Adept's Carrioncaller.png";
import axe8 from "assets/albion-gallery/Adept's Crystal Reaper.png";
import axe2 from "assets/albion-gallery/Adept's Greataxe.png";
import axe3 from "assets/albion-gallery/Adept's Halberd.png";
import axe5 from "assets/albion-gallery/Adept's Infernal Scythe.png";
import axe7 from "assets/albion-gallery/Adept's Realmbreaker.png";

import mace4 from "assets/albion-gallery/Adept's Bedrock Mace.png";
import mace6 from "assets/albion-gallery/Adept's Camlann Mace.png";
import mace8 from "assets/albion-gallery/Adept's Dreadstorm Monarch.png";
import mace2 from "assets/albion-gallery/Adept's Heavy Mace.png";
import mace5 from "assets/albion-gallery/Adept's Incubus Mace.png";
import mace1 from "assets/albion-gallery/Adept's Mace.png";
import mace3 from "assets/albion-gallery/Adept's Morning Star.png";
import mace7 from "assets/albion-gallery/Adept's Oathkeepers.png";

import hammer5 from "assets/albion-gallery/Adept's Forge Hammers.png";
import hammer3 from "assets/albion-gallery/Adept's Great Hammer.png";
import hammer6 from "assets/albion-gallery/Adept's Grovekeeper.png";
import hammer1 from "assets/albion-gallery/Adept's Hammer.png";
import hammer7 from "assets/albion-gallery/Adept's Hand of Justice.png";
import hammer2 from "assets/albion-gallery/Adept's Polehammer.png";
import hammer4 from "assets/albion-gallery/Adept's Tombhammer.png";

import glove2 from "assets/albion-gallery/Adept's Battle Bracers.png";
import glove1 from "assets/albion-gallery/Adept's Brawler Gloves.png";
import glove7 from "assets/albion-gallery/Adept's Fists of Avalon.png";
import glove8 from "assets/albion-gallery/Adept's Forcepulse Bracer.png";
import glove5 from "assets/albion-gallery/Adept's Hellfire Hands.png";
import glove6 from "assets/albion-gallery/Adept's Ravenstrike Cestus.png";
import glove3 from "assets/albion-gallery/Adept's Spiked Gauntlets.png";
import glove4 from "assets/albion-gallery/Adept's Ursine Maulers.png";

import crossbow8 from "assets/albion-gallery/Adept's Arclight Blasters.png";
import crossbow5 from "assets/albion-gallery/Adept's Boltcasters.png";
import crossbow1 from "assets/albion-gallery/Adept's Crossbow.png";
import crossbow7 from "assets/albion-gallery/Adept's Energy Shaper.png";
import crossbow2 from "assets/albion-gallery/Adept's Heavy Crossbow.png";
import crossbow3 from "assets/albion-gallery/Adept's Light Crossbow.png";
import crossbow6 from "assets/albion-gallery/Adept's Siegebow.png";
import crossbow4 from "assets/albion-gallery/Adept's Weeping Repeater.png";

import bow6 from "assets/albion-gallery/Adept's Bow of Badon.png";
import bow1 from "assets/albion-gallery/Adept's Bow.png";
import bow3 from "assets/albion-gallery/Adept's Longbow.png";
import bow7 from "assets/albion-gallery/Adept's Mistpiercer.png";
import bow8 from "assets/albion-gallery/Adept's Skystrider Bow.png";
import bow5 from "assets/albion-gallery/Adept's Wailing Bow.png";
import bow2 from "assets/albion-gallery/Adept's Warbow.png";
import bow4 from "assets/albion-gallery/Adept's Whispering Bow.png";

import dagger4 from "assets/albion-gallery/Adept's Bloodletter.png";
import dagger7 from "assets/albion-gallery/Adept's Bridled Fury.png";
import dagger3 from "assets/albion-gallery/Adept's Claws.png";
import dagger2 from "assets/albion-gallery/Adept's Dagger Pair.png";
import dagger1 from "assets/albion-gallery/Adept's Dagger.png";
import dagger6 from "assets/albion-gallery/Adept's Deathgivers.png";
import dagger5 from "assets/albion-gallery/Adept's Demonfang.png";
import dagger8 from "assets/albion-gallery/Adept's Twin Slayers.png";

import spear7 from "assets/albion-gallery/Adept's Daybreaker.png";
import spear3 from "assets/albion-gallery/Adept's Glaive.png";
import spear4 from "assets/albion-gallery/Adept's Heron Spear.png";
import spear2 from "assets/albion-gallery/Adept's Pike.png";
import spear8 from "assets/albion-gallery/Adept's Rift Glaive.png";
import spear1 from "assets/albion-gallery/Adept's Spear.png";
import spear5 from "assets/albion-gallery/Adept's Spirithunter.png";
import spear6 from "assets/albion-gallery/Adept's Trinity Spear.png";

import quarter4 from "assets/albion-gallery/Adept's Black Monk Stave.png";
import quarter3 from "assets/albion-gallery/Adept's Double Bladed Staff.png";
import quarter7 from "assets/albion-gallery/Adept's Grailseeker.png";
import quarter2 from "assets/albion-gallery/Adept's Iron-clad Staff.png";
import quarter8 from "assets/albion-gallery/Adept's Phantom Twinblade.png";
import quarter1 from "assets/albion-gallery/Adept's Quarterstaff.png";
import quarter5 from "assets/albion-gallery/Adept's Soulscythe.png";
import quarter6 from "assets/albion-gallery/Adept's Staff of Balance.png";

import shapeshifter4 from "assets/albion-gallery/Adept's Bloodmoon Staff.png";
import shapeshifter6 from "assets/albion-gallery/Adept's Earthrune Staff.png";
import shapeshifter5 from "assets/albion-gallery/Adept's Hellspawn Staff.png";
import shapeshifter7 from "assets/albion-gallery/Adept's Lightcaller.png";
import shapeshifter3 from "assets/albion-gallery/Adept's Primal Staff.png";
import shapeshifter1 from "assets/albion-gallery/Adept's Prowling Staff.png";
import shapeshifter2 from "assets/albion-gallery/Adept's Rootbound Staff.png";

import nature5 from "assets/albion-gallery/Adept's Blight Staff.png";
import nature4 from "assets/albion-gallery/Adept's Druidic Staff.png";
import nature8 from "assets/albion-gallery/Adept's Forgebark Staff.png";
import nature2 from "assets/albion-gallery/Adept's Great Nature Staff.png";
import nature7 from "assets/albion-gallery/Adept's Ironroot Staff.png";
import nature1 from "assets/albion-gallery/Adept's Nature Staff.png";
import nature6 from "assets/albion-gallery/Adept's Rampant Staff.png";
import nature3 from "assets/albion-gallery/Adept's Wild Staff.png";

import fire6 from "assets/albion-gallery/Adept's Blazing Staff.png";
import fire5 from "assets/albion-gallery/Adept's Brimstone Staff.png";
import fire7 from "assets/albion-gallery/Adept's Dawnsong.png";
import fire1 from "assets/albion-gallery/Adept's Fire Staff.png";
import fire8 from "assets/albion-gallery/Adept's Flamewalker Staff.png";
import fire2 from "assets/albion-gallery/Adept's Great Fire Staff.png";
import fire3 from "assets/albion-gallery/Adept's Infernal Staff.png";
import fire4 from "assets/albion-gallery/Adept's Wild Staff.png";

import holy3 from "assets/albion-gallery/Adept's Divine Staff.png";
import holy8 from "assets/albion-gallery/Adept's Exalted Staff.png"; //
import holy5 from "assets/albion-gallery/Adept's Fallen Staff.png";
import holy2 from "assets/albion-gallery/Adept's Great Holy Staff.png";
import holy7 from "assets/albion-gallery/Adept's Hallowfall.png";
import holy1 from "assets/albion-gallery/Adept's Holy Staff.png";
import holy4 from "assets/albion-gallery/Adept's Lifetouch Staff.png";
import holy6 from "assets/albion-gallery/Adept's Redemption Staff.png";

import arcane1 from "assets/albion-gallery/Adept's Arcane Staff.png";
import arcane8 from "assets/albion-gallery/Adept's Astral Staff.png";
import arcane3 from "assets/albion-gallery/Adept's Enigmatic Staff.png";
import arcane7 from "assets/albion-gallery/Adept's Evensong.png";
import arcane2 from "assets/albion-gallery/Adept's Great Arcane Staff.png";
import arcane6 from "assets/albion-gallery/Adept's Malevolent Locus.png";
import arcane5 from "assets/albion-gallery/Adept's Occult Staff.png";
import arcane4 from "assets/albion-gallery/Adept's Witchwork Staff.png";

import frost8 from "assets/albion-gallery/Adept's Arctic Staff.png";
import frost7 from "assets/albion-gallery/Adept's Chillhowl.png";
import frost1 from "assets/albion-gallery/Adept's Frost Staff.png";
import frost3 from "assets/albion-gallery/Adept's Glacial Staff.png";
import frost2 from "assets/albion-gallery/Adept's Great Frost Staff.png";
import frost4 from "assets/albion-gallery/Adept's Hoarfrost Staff.png";
import frost5 from "assets/albion-gallery/Adept's Icicle Staff.png";
import frost6 from "assets/albion-gallery/Adept's Permafrost Prism.png";

import curse5 from "assets/albion-gallery/Adept's Cursed Skull.png";
import curse1 from "assets/albion-gallery/Adept's Cursed Staff.png";
import curse6 from "assets/albion-gallery/Adept's Damnation Staff.png";
import curse3 from "assets/albion-gallery/Adept's Demonic Staff.png";
import curse2 from "assets/albion-gallery/Adept's Great Cursed Staff.png";
import curse4 from "assets/albion-gallery/Adept's Lifecurse Staff.png";
import curse8 from "assets/albion-gallery/Adept's Rotcaller Staff.png"; //
import curse7 from "assets/albion-gallery/Adept's Shadowcaller.png";

import shield5 from "assets/albion-gallery/Adept's Astral Aegis.png";
import shield3 from "assets/albion-gallery/Adept's Caitiff Shield.png";
import shield4 from "assets/albion-gallery/Adept's Facebreaker.png";
import shield2 from "assets/albion-gallery/Adept's Sarcophagus.png";
import shield1 from "assets/albion-gallery/Adept's Shield.png";

import torch4 from "assets/albion-gallery/Adept's Cryptcandle.png";
import torch3 from "assets/albion-gallery/Adept's Leering Cane.png";
import torch2 from "assets/albion-gallery/Adept's Mistcaller.png";
import torch5 from "assets/albion-gallery/Adept's Sacred Scepter.png";
import torch1 from "assets/albion-gallery/Adept's Torch.png";

import tome5 from "assets/albion-gallery/Adept's Celestial Censer.png";
import tome2 from "assets/albion-gallery/Adept's Eye of Secrets.png";
import tome3 from "assets/albion-gallery/Adept's Muisak.png";
import tome4 from "assets/albion-gallery/Adept's Taproot.png";
import tome1 from "assets/albion-gallery/Adept's Tome of Spells.png";

// import xxxx1 from "assets/albion-gallery/";
// import xxxx2 from "assets/albion-gallery/";
// import xxxx3 from "assets/albion-gallery/";
// import xxxx4 from "assets/albion-gallery/";
// import xxxx5 from "assets/albion-gallery/";
// import xxxx6 from "assets/albion-gallery/";
// import xxxx7 from "assets/albion-gallery/";
// import xxxx8 from "assets/albion-gallery/";

// cloth
import robe2 from "assets/albion-gallery/Adept's Cleric Robe.png";
import robe8 from "assets/albion-gallery/Adept's Cultist Robe.png";
import robe4 from "assets/albion-gallery/Adept's Druid Robe.png";
import robe7 from "assets/albion-gallery/Adept's Feyscale Robe.png";
import robe6 from "assets/albion-gallery/Adept's Fiend Robe.png";
import robe3 from "assets/albion-gallery/Adept's Mage Robe.png";
import robe9 from "assets/albion-gallery/Adept's Robe of Purity.png";
import robe5 from "assets/albion-gallery/Adept's Royal Robe.png";
import robe1 from "assets/albion-gallery/Adept's Scholar Robe.png";

import cowl2 from "assets/albion-gallery/Adept's Cleric Cowl.png";
import cowl9 from "assets/albion-gallery/Adept's Cowl of Purity.png";
import cowl8 from "assets/albion-gallery/Adept's Cultist Cowl.png";
import cowl4 from "assets/albion-gallery/Adept's Druid Cowl.png";
import cowl7 from "assets/albion-gallery/Adept's Feyscale Hat.png";
import cowl6 from "assets/albion-gallery/Adept's Fiend Cowl.png";
import cowl3 from "assets/albion-gallery/Adept's Mage Cowl.png";
import cowl5 from "assets/albion-gallery/Adept's Royal Cowl.png";
import cowl1 from "assets/albion-gallery/Adept's Scholar Cowl.png";

import sandal2 from "assets/albion-gallery/Adept's Cleric Sandals.png";
import sandal8 from "assets/albion-gallery/Adept's Cultist Sandals.png";
import sandal4 from "assets/albion-gallery/Adept's Druid Sandals.png";
import sandal6 from "assets/albion-gallery/Adept's Feyscale Sandals.png";
import sandal7 from "assets/albion-gallery/Adept's Fiend Sandals.png";
import sandal3 from "assets/albion-gallery/Adept's Mage Sandals.png";
import sandal5 from "assets/albion-gallery/Adept's Royal Sandals.png";
import sandal9 from "assets/albion-gallery/Adept's Sandals of Purity.png";
import sandal1 from "assets/albion-gallery/Adept's Scholar Sandals.png";

// leather
import jacket3 from "assets/albion-gallery/Adept's Assassin Jacket.png";
import jacket6 from "assets/albion-gallery/Adept's Hellion Jacket.png";
import jacket2 from "assets/albion-gallery/Adept's Hunter Jacket.png";
import jacket9 from "assets/albion-gallery/Adept's Jacket of Tenacity.png";
import jacket1 from "assets/albion-gallery/Adept's Mercenary Jacket.png";
import jacket7 from "assets/albion-gallery/Adept's Mistwalker Jacket.png";
import jacket5 from "assets/albion-gallery/Adept's Royal Jacket.png";
import jacket8 from "assets/albion-gallery/Adept's Specter Jacket.png";
import jacket4 from "assets/albion-gallery/Adept's Stalker Jacket.png";

import hood3 from "assets/albion-gallery/Adept's Assassin Hood.png";
import hood6 from "assets/albion-gallery/Adept's Hellion Hood.png";
import hood9 from "assets/albion-gallery/Adept's Hood of Tenacity.png";
import hood2 from "assets/albion-gallery/Adept's Hunter Hood.png";
import hood1 from "assets/albion-gallery/Adept's Mercenary Hood.png";
import hood7 from "assets/albion-gallery/Adept's Mistwalker Hood.png";
import hood5 from "assets/albion-gallery/Adept's Royal Hood.png";
import hood8 from "assets/albion-gallery/Adept's Specter Hood.png";
import hood4 from "assets/albion-gallery/Adept's Stalker Hood.png";

import shoe2 from "assets/albion-gallery/Adept's Assassin Shoes.png";
import shoe6 from "assets/albion-gallery/Adept's Hellion Shoes.png";
import shoe3 from "assets/albion-gallery/Adept's Hunter Shoes.png";
import shoe1 from "assets/albion-gallery/Adept's Mercenary Shoes.png";
import shoe7 from "assets/albion-gallery/Adept's Mistwalker Shoes.png";
import shoe5 from "assets/albion-gallery/Adept's Royal Shoes.png";
import shoe9 from "assets/albion-gallery/Adept's Shoes of Tenacity.png";
import shoe8 from "assets/albion-gallery/Adept's Specter Shoes.png";
import shoe4 from "assets/albion-gallery/Adept's Stalker Shoes.png";

// plate
import armor9 from "assets/albion-gallery/Adept's Armor of Valor.png";
import armor6 from "assets/albion-gallery/Adept's Demon Armor.png";
import armor7 from "assets/albion-gallery/Adept's Duskweaver Armor.png";
import armor5 from "assets/albion-gallery/Adept's Graveguard Armor.png";
import armor3 from "assets/albion-gallery/Adept's Guardian Armor.png";
import armor8 from "assets/albion-gallery/Adept's Judicator Armor.png";
import armor2 from "assets/albion-gallery/Adept's Knight Armor.png";
import armor4 from "assets/albion-gallery/Adept's Royal Armor.png";
import armor1 from "assets/albion-gallery/Adept's Soldier Armor.png";

import helmet6 from "assets/albion-gallery/Adept's Demon Helmet.png";
import helmet7 from "assets/albion-gallery/Adept's Duskweaver Helmet.png";
import helmet5 from "assets/albion-gallery/Adept's Graveguard Helmet.png";
import helmet3 from "assets/albion-gallery/Adept's Guardian Helmet.png";
import helmet9 from "assets/albion-gallery/Adept's Helmet of Valor.png";
import helmet8 from "assets/albion-gallery/Adept's Judicator Helmet.png";
import helmet2 from "assets/albion-gallery/Adept's Knight Helmet.png";
import helmet4 from "assets/albion-gallery/Adept's Royal Helmet.png";
import helmet1 from "assets/albion-gallery/Adept's Soldier Helmet.png";

import boot9 from "assets/albion-gallery/Adept's Boots of Valor.png";
import boot6 from "assets/albion-gallery/Adept's Demon Boots.png";
import boot7 from "assets/albion-gallery/Adept's Duskweaver Boots.png";
import boot5 from "assets/albion-gallery/Adept's Graveguard Boots.png";
import boot3 from "assets/albion-gallery/Adept's Guardian Boots.png";
import boot8 from "assets/albion-gallery/Adept's Judicator Boots.png";
import boot2 from "assets/albion-gallery/Adept's Knight Boots.png";
import boot4 from "assets/albion-gallery/Adept's Royal Boots.png";
import boot1 from "assets/albion-gallery/Adept's Soldier Boots.png";

// potion
import potion4 from "assets/albion-gallery/Invisibility Potion.png";
import potion3 from "assets/albion-gallery/Major Acid Potion.png";
import potion5 from "assets/albion-gallery/Major Berserk Potion.png";
import potion2 from "assets/albion-gallery/Major Gigantify Potion.png";
import potion6 from "assets/albion-gallery/Major Poison Potion.png";
import potion1 from "assets/albion-gallery/Major Resistance Potion.png";
import potion8 from "assets/albion-gallery/T3_POTION_MOB_RESET@2.png";
import potion7 from "assets/albion-gallery/T5_POTION_SLOWFIELD.png";
import potion9 from "assets/albion-gallery/T7_POTION_CLEANSE2.png";

// food
import food2 from "assets/albion-gallery/Beef Stew.png";
import food1 from "assets/albion-gallery/Deadwater Eel Stew.png";
import food3 from "assets/albion-gallery/Dusthole Crab Omelette.png";
import food4 from "assets/albion-gallery/Pork Omelette.png";
import food11 from "assets/albion-gallery/T5_MEAL_SOUP.png";
import food7 from "assets/albion-gallery/T7_MEAL_OMELETTE_AVALON.png";
import food8 from "assets/albion-gallery/T7_MEAL_ROAST.png";
import food9 from "assets/albion-gallery/T7_MEAL_ROAST_FISH.png";
import food10 from "assets/albion-gallery/T8_FISH_FRESHWATER_ALL_COMMON.png";
import food5 from "assets/albion-gallery/T8_MEAL_SANDWICH.png";
import food6 from "assets/albion-gallery/T8_MEAL_SANDWICH_AVALON.png";

// cape
import cape7 from "assets/albion-gallery/Adept's Brecilien Cape.png";
import cape6 from "assets/albion-gallery/Adept's Bridgewatch Cape.png";
import cape1 from "assets/albion-gallery/Adept's Cape.png";
import cape5 from "assets/albion-gallery/Adept's Fort Sterling Cape.png";
import cape8 from "assets/albion-gallery/Adept's Keeper Cape.png";
import cape2 from "assets/albion-gallery/Adept's Lymhurst Cape.png";
import cape3 from "assets/albion-gallery/Adept's Martlock Cape.png";
import cape4 from "assets/albion-gallery/Adept's Morgana Cape.png";
import cape10 from "assets/albion-gallery/T4_CAPEITEM_DEMON.png";
import cape9 from "assets/albion-gallery/T4_CAPEITEM_SMUGGLER.png";

export const gallery = [
  {
    name: "sword",
    list: [sword1, sword2, sword3, sword4, sword5, sword6, sword7, sword8],
    type: 4,
  },
  {
    name: "axe",
    list: [axe1, axe2, axe3, axe4, axe5, axe6, axe7, axe8],
    type: 4,
  },
  {
    name: "mace",
    list: [mace1, mace2, mace3, mace4, mace5, mace6, mace7, mace8],
    type: 4,
  },
  {
    name: "hammer",
    list: [hammer1, hammer2, hammer3, hammer4, hammer5, hammer6, hammer7],
    type: 4,
  },
  {
    name: "glove",
    list: [glove1, glove2, glove3, glove4, glove5, glove6, glove7, glove8],
    type: 4,
  },
  {
    name: "crossbow",
    list: [
      crossbow1,
      crossbow2,
      crossbow3,
      crossbow4,
      crossbow5,
      crossbow6,
      crossbow7,
      crossbow8,
    ],
    type: 4,
  },
  {
    name: "bow",
    list: [bow1, bow2, bow3, bow4, bow5, bow6, bow7, bow8],
    type: 4,
  },
  {
    name: "dagger",
    list: [
      dagger1,
      dagger2,
      dagger3,
      dagger4,
      dagger5,
      dagger6,
      dagger7,
      dagger8,
    ],
    type: 4,
  },
  {
    name: "spear",
    list: [spear1, spear2, spear3, spear4, spear5, spear6, spear7, spear8],
    type: 4,
  },
  {
    name: "quarter",
    list: [
      quarter1,
      quarter2,
      quarter3,
      quarter4,
      quarter5,
      quarter6,
      quarter7,
      quarter8,
    ],
    type: 4,
  },
  {
    name: "shapeshifter",
    list: [
      shapeshifter1,
      shapeshifter2,
      shapeshifter3,
      shapeshifter4,
      shapeshifter5,
      shapeshifter6,
      shapeshifter7,
    ],
    type: 4,
  },
  {
    name: "nature",
    list: [
      nature1,
      nature2,
      nature3,
      nature4,
      nature5,
      nature6,
      nature7,
      nature8,
    ],
    type: 4,
  },
  {
    name: "fire",
    list: [fire1, fire2, fire3, fire4, fire5, fire6, fire7, fire8],
    type: 4,
  },
  {
    name: "holy",
    list: [holy1, holy2, holy3, holy4, holy5, holy6, holy7, holy8],
    type: 4,
  },
  {
    name: "arcane",
    list: [
      arcane1,
      arcane2,
      arcane3,
      arcane4,
      arcane5,
      arcane6,
      arcane7,
      arcane8,
    ],
    type: 4,
  },
  {
    name: "frost",
    list: [frost1, frost2, frost3, frost4, frost5, frost6, frost7, frost8],
    type: 4,
  },
  {
    name: "curse",
    list: [curse1, curse2, curse3, curse4, curse5, curse6, curse7, curse8],
    type: 4,
  },
  {
    name: "shield",
    list: [shield1, shield2, shield3, shield4, shield5],
    type: 6,
  },
  {
    name: "torch",
    list: [torch1, torch2, torch3, torch4, torch5],
    type: 6,
  },
  {
    name: "tome",
    list: [tome1, tome2, tome3, tome4, tome5],
    type: 6,
  },
  {
    name: "cowl",
    list: [cowl1, cowl2, cowl3, cowl4, cowl5, cowl6, cowl7, cowl8, cowl9],
    type: 2,
  },
  {
    name: "hood",
    list: [hood1, hood2, hood3, hood4, hood5, hood6, hood7, hood8, hood9],
    type: 2,
  },
  {
    name: "helmet",
    list: [
      helmet1,
      helmet2,
      helmet3,
      helmet4,
      helmet5,
      helmet6,
      helmet7,
      helmet8,
      helmet9,
    ],
    type: 2,
  },
  {
    name: "robe",
    list: [robe1, robe2, robe3, robe4, robe5, robe6, robe7, robe8, robe9],
    type: 5,
  },
  {
    name: "jacket",
    list: [
      jacket1,
      jacket2,
      jacket3,
      jacket4,
      jacket5,
      jacket6,
      jacket7,
      jacket8,
      jacket9,
    ],
    type: 5,
  },
  {
    name: "armor",
    list: [
      armor1,
      armor2,
      armor3,
      armor4,
      armor5,
      armor6,
      armor7,
      armor8,
      armor9,
    ],
    type: 5,
  },
  {
    name: "sandal",
    list: [
      sandal1,
      sandal2,
      sandal3,
      sandal4,
      sandal5,
      sandal6,
      sandal7,
      sandal8,
      sandal9,
    ],
    type: 8,
  },
  {
    name: "shoe",
    list: [shoe1, shoe2, shoe3, shoe4, shoe5, shoe6, shoe7, shoe8, shoe9],
    type: 8,
  },
  {
    name: "boot",
    list: [boot1, boot2, boot3, boot4, boot5, boot6, boot7, boot8, boot9],
    type: 8,
  },
  {
    name: "potion",
    list: [
      potion8,
      potion7,
      potion1,
      potion2,
      potion3,
      potion9,
      potion4,
      potion5,
      potion6,
    ],
    type: 7,
  },
  {
    name: "food",
    list: [
      food11,
      food3,
      food4,
      food7,
      food8,
      food9,
      food10,
      food1,
      food2,
      food5,
      food6,
    ],
    type: 9,
  },
  {
    name: "cape",
    list: [
      cape1,
      cape2,
      cape3,
      cape9,
      cape4,
      cape5,
      cape6,
      cape7,
      cape8,
      cape10,
    ],
    type: 3,
  },
];
// export const gallery_online = [
//   {
//     name: "arcane",
//     list: [
//       "MAIN_ARCANESTAFF",
//       "2H_ARCANESTAFF",
//       "2H_ENIGMATICSTAFF",
//       "MAIN_ARCANESTAFF_UNDEAD",
//       "2H_ARCANESTAFF_HELL",
//       "2H_ENIGMATICORB_MORGANA",
//       "2H_ARCANE_RINGPAIR_AVALON",
//       "2H_ARCANESTAFF_CRYSTAL",
//     ],
//     type: 4,
//   },
//   {
//     name: "axe",
//     list: [
//       "MAIN_AXE",
//       "2H_AXE",
//       "2H_HALBERD",
//       "2H_HALBERD_MORGANA",
//       "2H_SCYTHE_HELL",
//       "2H_DUALAXE_KEEPER",
//       "2H_AXE_AVALON",
//       "2H_SCYTHE_CRYSTAL",
//     ],
//     type: 4,
//   },
//   {
//     name: "bow",
//     list: [
//       "2H_BOW",
//       "2H_WARBOW",
//       "2H_LONGBOW",
//       "2H_LONGBOW_UNDEAD",
//       "2H_BOW_HELL",
//       "2H_BOW_KEEPER",
//       "2H_BOW_AVALON",
//       "2H_BOW_CRYSTAL",
//     ],
//     type: 4,
//   },
//   {
//     name: "crossbow",
//     list: [
//       "2H_CROSSBOW",
//       "2H_CROSSBOWLARGE",
//       "MAIN_1HCROSSBOW",
//       "2H_REPEATINGCROSSBOW_UNDEAD",
//       "2H_DUALCROSSBOW_HELL",
//       "2H_CROSSBOWLARGE_MORGANA",
//       "2H_CROSSBOW_CANNON_AVALON",
//       "2H_DUALCROSSBOW_CRYSTAL",
//     ],
//     type: 4,
//   },
//   {
//     name: "curse",
//     list: [
//       "MAIN_CURSEDSTAFF",
//       "2H_CURSEDSTAFF",
//       "2H_DEMONICSTAFF",
//       "MAIN_CURSEDSTAFF_UNDEAD",
//       "2H_SKULLORB_HELL",
//       "2H_CURSEDSTAFF_MORGANA",
//       "MAIN_CURSEDSTAFF_AVALON",
//       "MAIN_CURSEDSTAFF_CRYSTAL",
//     ],
//     type: 4,
//   },
//   {
//     name: "dagger",
//     list: [
//       "MAIN_DAGGER",
//       "2H_DAGGERPAIR",
//       "2H_CLAWPAIR",
//       "MAIN_RAPIER_MORGANA",
//       "MAIN_DAGGER_HELL",
//       "2H_DUALSICKLE_UNDEAD",
//       "2H_DAGGER_KATAR_AVALON",
//       "2H_DAGGERPAIR_CRYSTAL",
//     ],
//     type: 4,
//   },
//   {
//     name: "fire",
//     list: [
//       "MAIN_FIRESTAFF",
//       "2H_FIRESTAFF",
//       "2H_INFERNOSTAFF",
//       "MAIN_FIRESTAFF_KEEPER",
//       "2H_FIRESTAFF_HELL",
//       "2H_INFERNOSTAFF_MORGANA",
//       "2H_FIRE_RINGPAIR_AVALON",
//       "MAIN_FIRESTAFF_CRYSTAL",
//     ],
//     type: 4,
//   },
//   {
//     name: "frost",
//     list: [
//       "MAIN_FROSTSTAFF",
//       "2H_FROSTSTAFF",
//       "2H_GLACIALSTAFF",
//       "MAIN_FROSTSTAFF_KEEPER",
//       "2H_ICEGAUNTLETS_HELL",
//       "2H_ICECRYSTAL_UNDEAD",
//       "MAIN_FROSTSTAFF_AVALON",
//       "2H_FROSTSTAFF_CRYSTAL",
//     ],
//     type: 4,
//   },
//   {
//     name: "hammer",
//     list: [
//       "MAIN_HAMMER",
//       "2H_POLEHAMMER",
//       "2H_HAMMER",
//       "2H_HAMMER_UNDEAD",
//       "2H_DUALHAMMER_HELL",
//       "2H_RAM_KEEPER",
//       "2H_HAMMER_AVALON",
//       // "",
//     ],
//     type: 4,
//   },
//   {
//     name: "holy",
//     list: [
//       "MAIN_HOLYSTAFF",
//       "2H_HOLYSTAFF",
//       "2H_DIVINESTAFF",
//       "MAIN_HOLYSTAFF_MORGANA",
//       "2H_HOLYSTAFF_HELL",
//       "2H_HOLYSTAFF_UNDEAD",
//       "MAIN_HOLYSTAFF_AVALON",
//       "2H_HOLYSTAFF_CRYSTAL",
//     ],
//     type: 4,
//   },
//   {
//     name: "glove",
//     list: [
//       "2H_KNUCKLES_SET1",
//       "2H_KNUCKLES_SET2",
//       "2H_KNUCKLES_SET3",
//       "2H_KNUCKLES_KEEPER",
//       "2H_KNUCKLES_HELL",
//       "2H_KNUCKLES_MORGANA",
//       "2H_KNUCKLES_AVALON",
//       "2H_KNUCKLES_CRYSTAL",
//     ],
//     type: 4,
//   },
//   {
//     name: "mace",
//     list: [
//       "MAIN_MACE",
//       "2H_MACE",
//       "2H_FLAIL",
//       "MAIN_ROCKMACE_KEEPER",
//       "MAIN_MACE_HELL",
//       "2H_MACE_MORGANA",
//       "2H_DUALMACE_AVALON",
//       "MAIN_MACE_CRYSTAL",
//     ],
//     type: 4,
//   },
//   {
//     name: "nature",
//     list: [
//       "MAIN_NATURESTAFF",
//       "2H_NATURESTAFF",
//       "2H_WILDSTAFF",
//       "MAIN_NATURESTAFF_KEEPER",
//       "2H_NATURESTAFF_HELL",
//       "2H_NATURESTAFF_KEEPER",
//       "MAIN_NATURESTAFF_AVALON",
//       "MAIN_NATURESTAFF_CRYSTAL",
//     ],
//     type: 4,
//   },
//   {
//     name: "quarter",
//     list: [
//       "2H_QUARTERSTAFF",
//       "2H_IRONCLADEDSTAFF",
//       "2H_DOUBLEBLADEDSTAFF",
//       "2H_COMBATSTAFF_MORGANA",
//       "2H_TWINSCYTHE_HELL",
//       "2H_ROCKSTAFF_KEEPER",
//       "2H_QUARTERSTAFF_AVALON",
//       "2H_DOUBLEBLADEDSTAFF_CRYSTAL",
//     ],
//     type: 4,
//   },
//   {
//     name: "shapeshifter",
//     list: [
//       "2H_SHAPESHIFTER_SET1",
//       "2H_SHAPESHIFTER_SET2",
//       "2H_SHAPESHIFTER_SET3",
//       "2H_SHAPESHIFTER_MORGANA",
//       "2H_SHAPESHIFTER_HELL",
//       "2H_SHAPESHIFTER_KEEPER",
//       "2H_SHAPESHIFTER_AVALON",
//       // "",
//     ],
//     type: 4,
//   },
//   {
//     name: "spear",
//     list: [
//       "MAIN_SPEAR",
//       "2H_SPEAR",
//       "2H_GLAIVE",
//       "MAIN_SPEAR_KEEPER",
//       "2H_HARPOON_HELL",
//       "2H_TRIDENT_UNDEAD",
//       "MAIN_SPEAR_LANCE_AVALON",
//       "2H_GLAIVE_CRYSTAL",
//     ],
//     type: 4,
//   },
//   {
//     name: "sword",
//     list: [
//       "MAIN_SWORD",
//       "2H_CLAYMORE",
//       "2H_DUALSWORD",
//       "MAIN_SCIMITAR_MORGANA",
//       "2H_CLEAVER_HELL",
//       "2H_DUALSCIMITAR_UNDEAD",
//       "2H_CLAYMORE_AVALON",
//       "MAIN_SWORD_CRYSTAL",
//     ],
//     type: 4,
//   },
//   {
//     name: "tome",
//     list: [
//       "OFF_BOOK",
//       "OFF_ORB_MORGANA",
//       "OFF_DEMONSKULL_HELL",
//       "OFF_TOTEM_KEEPER",
//       "OFF_CENSER_AVALON",
//     ],
//     type: 6,
//   },
//   {
//     name: "shield",
//     list: [
//       "OFF_SHIELD",
//       "OFF_TOWERSHIELD_UNDEAD",
//       "OFF_SHIELD_HELL",
//       "OFF_SPIKEDSHIELD_MORGANA",
//       "OFF_SHIELD_AVALON",
//     ],
//     type: 6,
//   },
//   {
//     name: "torch",
//     list: [
//       "OFF_TORCH",
//       "OFF_HORN_KEEPER",
//       "OFF_JESTERCANE_HELL",
//       "OFF_LAMP_UNDEAD",
//       "OFF_TALISMAN_AVALON",
//     ],
//     type: 6,
//   },
//   {
//     name: "cowl",
//     list: [
//       "HEAD_CLOTH_SET1",
//       "HEAD_CLOTH_SET2",
//       "HEAD_CLOTH_SET3",
//       "HEAD_CLOTH_KEEPER",
//       "HEAD_CLOTH_ROYAL",
//       "HEAD_CLOTH_HELL",
//       "HEAD_CLOTH_FEY",
//       "HEAD_CLOTH_MORGANA",
//       "HEAD_CLOTH_AVALON",
//     ],
//     type: 2,
//   },
//   {
//     name: "hood",
//     list: [
//       "HEAD_LEATHER_SET1",
//       "HEAD_LEATHER_SET2",
//       "HEAD_LEATHER_SET3",
//       "HEAD_LEATHER_MORGANA",
//       "HEAD_LEATHER_ROYAL",
//       "HEAD_LEATHER_HELL",
//       "HEAD_LEATHER_FEY",
//       "HEAD_LEATHER_UNDEAD",
//       "HEAD_LEATHER_AVALON",
//     ],
//     type: 2,
//   },
//   {
//     name: "helmet",
//     list: [
//       "HEAD_PLATE_SET1",
//       "HEAD_PLATE_SET2",
//       "HEAD_PLATE_SET3",
//       "HEAD_PLATE_UNDEAD",
//       "HEAD_PLATE_ROYAL",
//       "HEAD_PLATE_HELL",
//       "HEAD_PLATE_FEY",
//       "HEAD_PLATE_KEEPER",
//       "HEAD_PLATE_AVALON",
//     ],
//     type: 2,
//   },
//   {
//     name: "robe",
//     list: [
//       "ARMOR_CLOTH_SET1",
//       "ARMOR_CLOTH_SET2",
//       "ARMOR_CLOTH_SET3",
//       "ARMOR_CLOTH_KEEPER",
//       "ARMOR_CLOTH_ROYAL",
//       "ARMOR_CLOTH_HELL",
//       "ARMOR_CLOTH_FEY",
//       "ARMOR_CLOTH_MORGANA",
//       "ARMOR_CLOTH_AVALON",
//     ],
//     type: 5,
//   },
//   {
//     name: "jacket",
//     list: [
//       "ARMOR_LEATHER_SET1",
//       "ARMOR_LEATHER_SET2",
//       "ARMOR_LEATHER_SET3",
//       "ARMOR_LEATHER_MORGANA",
//       "ARMOR_LEATHER_ROYAL",
//       "ARMOR_LEATHER_HELL",
//       "ARMOR_LEATHER_FEY",
//       "ARMOR_LEATHER_UNDEAD",
//       "ARMOR_LEATHER_AVALON",
//     ],
//     type: 5,
//   },
//   {
//     name: "armor",
//     list: [
//       "ARMOR_PLATE_SET1",
//       "ARMOR_PLATE_SET2",
//       "ARMOR_PLATE_SET3",
//       "ARMOR_PLATE_UNDEAD",
//       "ARMOR_PLATE_ROYAL",
//       "ARMOR_PLATE_HELL",
//       "ARMOR_PLATE_FEY",
//       "ARMOR_PLATE_KEEPER",
//       "ARMOR_PLATE_AVALON",
//     ],
//     type: 5,
//   },
//   {
//     name: "sandal",
//     list: [
//       "SHOES_CLOTH_SET1",
//       "SHOES_CLOTH_SET2",
//       "SHOES_CLOTH_SET3",
//       "SHOES_CLOTH_KEEPER",
//       "SHOES_CLOTH_ROYAL",
//       "SHOES_CLOTH_HELL",
//       "SHOES_CLOTH_FEY",
//       "SHOES_CLOTH_MORGANA",
//       "SHOES_CLOTH_AVALON",
//     ],
//     type: 8,
//   },
//   {
//     name: "shoe",
//     list: [
//       "SHOES_LEATHER_SET1",
//       "SHOES_LEATHER_SET2",
//       "SHOES_LEATHER_SET3",
//       "SHOES_LEATHER_MORGANA",
//       "SHOES_LEATHER_ROYAL",
//       "SHOES_LEATHER_HELL",
//       "SHOES_LEATHER_FEY",
//       "SHOES_LEATHER_UNDEAD",
//       "SHOES_LEATHER_AVALON",
//     ],
//     type: 8,
//   },
//   {
//     name: "boot",
//     list: [
//       "SHOES_PLATE_SET1",
//       "SHOES_PLATE_SET2",
//       "SHOES_PLATE_SET3",
//       "SHOES_PLATE_UNDEAD",
//       "SHOES_PLATE_ROYAL",
//       "SHOES_PLATE_HELL",
//       "SHOES_PLATE_FEY",
//       "SHOES_PLATE_KEEPER",
//       "SHOES_PLATE_AVALON",
//     ],
//     type: 8,
//   },
//   {
//     name: "potion",
//     list: [
//       "T8_POTION_COOLDOWN",
//       "T8_POTION_CLEANSE",
//       "T8_POTION_BERSERK",
//       "T7_POTION_REVIVE",
//       "T7_POTION_STONESKIN",
//       "T7_POTION_SLOWFIELD",
//       "T7_POTION_ACID",
//     ],
//     type: 7,
//   },
//   {
//     name: "food",
//     list: [
//       "T8_MEAL_STEW",
//       "T8_MEAL_STEW_FISH",
//       "T8_MEAL_SANDWICH",
//       "T8_MEAL_SANDWICH_AVALON",
//       "T7_MEAL_OMELETTE_AVALON",
//       "T7_MEAL_OMELETTE",
//       "T7_MEAL_OMELETTE_FISH",
//     ],
//     type: 9,
//   },
//   {
//     name: "cape",
//     list: [
//       "CAPEITEM_AVALON",
//       "CAPEITEM_DEMON",
//       "CAPEITEM_FW_BRECILIEN",
//       "CAPEITEM_FW_BRIDGEWATCH",
//       "CAPEITEM_FW_CAERLEON",
//       "CAPEITEM_FW_FORTSTERLING",
//       "CAPEITEM_FW_LYMHURST",
//       "CAPEITEM_FW_MARTLOCK",
//       "CAPEITEM_FW_THETFORD",
//       "CAPEITEM_HERETIC",
//       "CAPEITEM_KEEPER",
//       "CAPEITEM_MORGANA",
//       "CAPEITEM_SMUGGLER",
//       "CAPEITEM_UNDEAD",
//     ],
//     type: 3,
//   },
//   {
//     name: "",
//     list: ["", "", "", "", "", "", "", "", ""],
//   },
// ];
